// extracted by mini-css-extract-plugin
module.exports = {"container":"Error_container__1Jl4R","nav":"Error_nav__3Ky8I","navTitle":"Error_navTitle__2L0mB","navBtn":"Error_navBtn__31u1q"};